<template>
  <!-- `https://docs.google.com/gview?url=${privacyPolicyUrl}&embedded=true` -->
  <iframe :src="`${privacyPolicyUrl}`" style="width: 100%; height: 500px" frameborder="0"></iframe>
</template>
<script>
  import appConfig from '@/config/app.js';
  export default {
    name: 'termsAndConditionsTemplate',
    data() {
      return {
        privacyPolicyUrl: appConfig.privacyPolicyUrl,
      };
    },
  };
</script>
